import makeTable from "./makeTable";

export enum ColumnId {
	// base start
	CallSign = "callSign",
	LastName = "lastName",
	FirstName = "firstName",
	MiddleName = "middleName",
	// block 1 str 1
	OwnOrdersCreateOrderCommissionAmount = "ownOrdersCreateOrderCommissionAmount",
	OwnOrdersCreateOrderCommissionCount = "ownOrdersCreateOrderCommissionCount",
	OwnOrdersCreateOrderCommissionCommission = "ownOrdersCreateOrderCommissionCommission",
	OwnOrdersCreateOrderCommissionAmountSuccessful = "ownOrdersCreateOrderCommissionAmountSuccessful",
	OwnOrdersCreateOrderCommissionCountSuccessful = "ownOrdersCreateOrderCommissionCountSuccessful",
	OwnOrdersCreateOrderCommissionCommissionSuccessful = "ownOrdersCreateOrderCommissionCommissionSuccessful",
	// block 1 str 2
	OwnOrdersSentToExecutionCommissionAmount = "ownOrdersSentToExecutionCommissionAmount",
	OwnOrdersSentToExecutionCommissionCount = "ownOrdersSentToExecutionCommissionCount",
	OwnOrdersSentToExecutionCommissionCommission = "ownOrdersSentToExecutionCommissionCommission",
	OwnOrdersSentToExecutionCommissionAmountSuccessful = "ownOrdersSentToExecutionCommissionAmountSuccessful",
	OwnOrdersSentToExecutionCommissionCountSuccessful = "ownOrdersSentToExecutionCommissionCountSuccessful",
	OwnOrdersSentToExecutionCommissionCommissionSuccessful = "ownOrdersSentToExecutionCommissionCommissionSuccessful",
	// block 1 str 3
	OwnOrdersPhoneOrderCommissionAmount = "ownOrdersPhoneOrderCommissionAmount",
	OwnOrdersPhoneOrderCommissionCount = "ownOrdersPhoneOrderCommissionCount",
	OwnOrdersPhoneOrderCommissionCommission = "ownOrdersPhoneOrderCommissionCommission",
	OwnOrdersPhoneOrderCommissionAmountSuccessful = "ownOrdersPhoneOrderCommissionAmountSuccessful",
	OwnOrdersPhoneOrderCommissionCountSuccessful = "ownOrdersPhoneOrderCommissionCountSuccessful",
	OwnOrdersPhoneOrderCommissionCommissionSuccessful = "ownOrdersPhoneOrderCommissionCommissionSuccessful",
	// block 1 str 4
	OwnOrdersClosedOrderCommissionAmount = "ownOrdersClosedOrderCommissionAmount",
	OwnOrdersClosedOrderCommissionCount = "ownOrdersClosedOrderCommissionCount",
	OwnOrdersClosedOrderCommissionCommission = "ownOrdersClosedOrderCommissionCommission",
	OwnOrdersClosedOrderCommissionAmountSuccessful = "ownOrdersClosedOrderCommissionAmountSuccessful",
	OwnOrdersClosedOrderCommissionCountSuccessful = "ownOrdersClosedOrderCommissionCountSuccessful",
	OwnOrdersClosedOrderCommissionCommissionSuccessful = "ownOrdersClosedOrderCommissionCommissionSuccessful",
	// block 2 str 1
	SentToReassignmentCreateOrderCommissionAmount = "sentToReassignmentCreateOrderCommissionAmount",
	SentToReassignmentCreateOrderCommissionCount = "sentToReassignmentCreateOrderCommissionCount",
	SentToReassignmentCreateOrderCommissionCommission = "sentToReassignmentCreateOrderCommissionCommission",
	SentToReassignmentCreateOrderCommissionAmountSuccessful = "sentToReassignmentCreateOrderCommissionAmountSuccessful",
	SentToReassignmentCreateOrderCommissionCountSuccessful = "sentToReassignmentCreateOrderCommissionCountSuccessful",
	SentToReassignmentCreateOrderCommissionCommissionSuccessful = "sentToReassignmentCreateOrderCommissionCommissionSuccessful",
	// block 2 str 2
	SentToReassignmentSentToExecutionCommissionAmount = "sentToReassignmentSentToExecutionCommissionAmount",
	SentToReassignmentSentToExecutionCommissionCount = "sentToReassignmentSentToExecutionCommissionCount",
	SentToReassignmentSentToExecutionCommissionCommission = "sentToReassignmentSentToExecutionCommissionCommission",
	SentToReassignmentSentToExecutionCommissionAmountSuccessful = "sentToReassignmentSentToExecutionCommissionAmountSuccessful",
	SentToReassignmentSentToExecutionCommissionCountSuccessful = "sentToReassignmentSentToExecutionCommissionCountSuccessful",
	SentToReassignmentSentToExecutionCommissionCommissionSuccessful = "sentToReassignmentSentToExecutionCommissionCommissionSuccessful",
	// block 2 str 3
	SentToReassignmentPhoneOrderCommissionAmount = "sentToReassignmentPhoneOrderCommissionAmount",
	SentToReassignmentPhoneOrderCommissionCount = "sentToReassignmentPhoneOrderCommissionCount",
	SentToReassignmentPhoneOrderCommissionCommission = "sentToReassignmentPhoneOrderCommissionCommission",
	SentToReassignmentPhoneOrderCommissionAmountSuccessful = "sentToReassignmentPhoneOrderCommissionAmountSuccessful",
	SentToReassignmentPhoneOrderCommissionCountSuccessful = "sentToReassignmentPhoneOrderCommissionCountSuccessful",
	SentToReassignmentPhoneOrderCommissionCommissionSuccessful = "sentToReassignmentPhoneOrderCommissionCommissionSuccessful",
	// block 2 str 4
	SentToReassignmentClosedOrderCommissionAmount = "sentToReassignmentClosedOrderCommissionAmount",
	SentToReassignmentClosedOrderCommissionCount = "sentToReassignmentClosedOrderCommissionCount",
	SentToReassignmentClosedOrderCommissionCommission = "sentToReassignmentClosedOrderCommissionCommission",
	SentToReassignmentClosedOrderCommissionAmountSuccessful = "sentToReassignmentClosedOrderCommissionAmountSuccessful",
	SentToReassignmentClosedOrderCommissionCountSuccessful = "sentToReassignmentClosedOrderCommissionCountSuccessful",
	SentToReassignmentClosedOrderCommissionCommissionSuccessful = "sentToReassignmentClosedOrderCommissionCommissionSuccessful",
	// block 3 str 1
	AcceptedFromReassignmentSentToExecutionCommissionAmount = "acceptedFromReassignmentSentToExecutionCommissionAmount",
	AcceptedFromReassignmentSentToExecutionCommissionCount = "acceptedFromReassignmentSentToExecutionCommissionCount",
	AcceptedFromReassignmentSentToExecutionCommissionCommission = "acceptedFromReassignmentSentToExecutionCommissionCommission",
	AcceptedFromReassignmentSentToExecutionCommissionAmountSuccessful = "acceptedFromReassignmentSentToExecutionCommissionAmountSuccessful",
	AcceptedFromReassignmentSentToExecutionCommissionCountSuccessful = "acceptedFromReassignmentSentToExecutionCommissionCountSuccessful",
	AcceptedFromReassignmentSentToExecutionCommissionCommissionSuccessful = "acceptedFromReassignmentSentToExecutionCommissionCommissionSuccessful",
	// block 3 str 2
	AcceptedFromReassignmentPhoneOrderCommissionAmount = "acceptedFromReassignmentPhoneOrderCommissionAmount",
	AcceptedFromReassignmentPhoneOrderCommissionCount = "acceptedFromReassignmentPhoneOrderCommissionCount",
	AcceptedFromReassignmentPhoneOrderCommissionCommission = "acceptedFromReassignmentPhoneOrderCommissionCommission",
	AcceptedFromReassignmentPhoneOrderCommissionAmountSuccessful = "acceptedFromReassignmentPhoneOrderCommissionAmountSuccessful",
	AcceptedFromReassignmentPhoneOrderCommissionCountSuccessful = "acceptedFromReassignmentPhoneOrderCommissionCountSuccessful",
	AcceptedFromReassignmentPhoneOrderCommissionCommissionSuccessful = "acceptedFromReassignmentPhoneOrderCommissionCommissionSuccessful",
	// block 3 str 3
	AcceptedFromReassignmentClosedOrderCommissionAmount = "acceptedFromReassignmentClosedOrderCommissionAmount",
	AcceptedFromReassignmentClosedOrderCommissionCount = "acceptedFromReassignmentClosedOrderCommissionCount",
	AcceptedFromReassignmentClosedOrderCommissionCommission = "acceptedFromReassignmentClosedOrderCommissionCommission",
	AcceptedFromReassignmentClosedOrderCommissionAmountSuccessful = "acceptedFromReassignmentClosedOrderCommissionAmountSuccessful",
	AcceptedFromReassignmentClosedOrderCommissionCountSuccessful = "acceptedFromReassignmentClosedOrderCommissionCountSuccessful",
	AcceptedFromReassignmentClosedOrderCommissionCommissionSuccessful = "acceptedFromReassignmentClosedOrderCommissionCommissionSuccessful",
	// base end
	Total = "total",
}

export const allColumns: ColumnId[] = Object.values(ColumnId);

export const translationTablePath =
	"mainPage.reports.salary.usersActivity.columns.";

const reportsSalaryUsersActivity = makeTable({
	allIds: allColumns,
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: allColumns,
	initialSortMethod: {
		column: ColumnId.CallSign,
		type: "asc",
	},
	initialWidths: Object.fromEntries(
		allColumns.map((id) => [id, 150]),
	) as Record<ColumnId, number>,
	initialResizable: Object.fromEntries(
		allColumns.map((id) => [id, true]),
	) as Record<ColumnId, boolean>,
	initialSortable: Object.fromEntries(
		allColumns.map((id) => [id, true]),
	) as Record<ColumnId, boolean>,
});

export default reportsSalaryUsersActivity;
